import React from 'react';
import InjectedPropsContext from './InjectedPropsContext';
import InjectedPropsProvider from './InjectedPropsProvider';

/**
 * This class enables an extension of the proiver-consumer pattern, basically it works in the form:
 * <Consumer> - Catches all parent providers of InjectedProps
 *    ... - Modifies the injected props via a "propModifier" function passed into this class as an attribute
 *        <Producer> - Sends the (injected) props that have now been modified on to their children.
 *
 * This can be useful to effectively scope specific injected props to be changed for children.
 */

const InjectedPropsModifier = ({ propModifier, children }) => (
  <InjectedPropsContext.Consumer>
    {parentGetProviderProps => (
      <InjectedPropsProvider
        getProviderProps={(consumerProps, propModifiers = []) => {
          return parentGetProviderProps(consumerProps, [propModifier, ...propModifiers]);
        }}
      >
        {children}
      </InjectedPropsProvider>
    )}
  </InjectedPropsContext.Consumer>
);

export { InjectedPropsModifier };
export default InjectedPropsModifier;
